<template>
  <div class="tg-login">
    <div class="tg-login--container" style="height: 200px">
      <h1 class="tg-login--title">Loading...</h1>
      <div :class="formClass" style="padding: 20px;">
        <el-progress :percentage="percent" :stroke-width="20"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      loaded: false,
      percent: 10,
      auth: false,
    };
  },
  computed: {
    title() {
      return this.$t("component.header.title");
    },
    formClass() {
      return ["tg-login--form", this.$route.name];
    },
  },
  props: {
    from: Object,
  },
  created() {
    let store = this.$store;

    setTimeout(this.checkLoaded, 500);

    if (store.state.app.lang.message == null) {
        let lang = Cookies.get("lang_code");

        if (!lang || lang == undefined || lang == "undefined") {
            lang = window.__default_lang;
        }

        store.dispatch("app/fetchLang", { lang }).then((response) => {
            this.loaded = true;
            this.auth = response.data.auth;
            this.percent = 100;
            if (response.data.auth) {
                this.$router.push(this.from ? this.from : {name: "home"});
            } else {
                this.$router.push({ name: "login" });
            }
        });
    } else {
        this.percent = 100;
        this.$router.push(this.from ? this.from : {name: "home"});
    }
  },
  methods: {
    checkLoaded() {
        if (this.percent == 100) {
            if (this.loaded) {
                if (this.auth) {
                    this.$router.push(this.from ? this.from : {name: "home"});
                } else {
                    this.$router.push({ name: "login" });
                }
            } else {
                this.$router.push(this.from ? this.from : {name: "home"});
            }
        } else {
            if (this.percent < 90) {
                this.percent += 10;
                setTimeout(this.checkLoaded, 200);
            }
        }
    }
  }
};
</script>